import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';

function AccessRequests() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const companyName = window.sessionStorage.getItem('companyName');
  useEffect(() => {
    const getApprovalRequests = async () => {
        try {
            const response = await axios.post('https://drobot-admin-v2-a2def93839bb.herokuapp.com/getaccessrequests', {
                companyname: companyName,
            }

            );
            const data = response.data;
            console.log(data);
            
            setRequests(data);
            setLoading(false);
        }
        catch (error) {
            console.error('Error fetching access requests:', error);
            toast.error('Error fetching access requests. Please try again.');
            setLoading(false);
        }
    };
    getApprovalRequests();
    },[]
    );
    const handleApproveRequest = async (uid) => {
        const promise = axios.post('https://drobot-admin-v2-a2def93839bb.herokuapp.com/acceptaccessrequest', {
          userUid: uid,
          companyname: companyName,
        });
      
        toast.promise(
          promise,
          {
            loading: 'Approving access request...',
            success: 'Access request approved successfully!',
            error: 'Error approving request. Please try again.',
          }
        );
      
        try {
          const response = await promise;
          const data = response.data;
      
          // optional: only remove if success confirmed
          if (response.status === 200) {
            setRequests((prev) => prev.filter((user) => user.uid !== uid));
          }
        } catch (error) {
          console.error('Error approving request:', error);
          // error toast already shown by toast.promise
        }
      };
      const handleRejectRequest = async (uid) => {
        const promise = axios.post('https://drobot-admin-v2-a2def93839bb.herokuapp.com/rejectaccessrequest', {
          userUid: uid,
          companyname: companyName,
        });
      
        toast.promise(
          promise,
          {
            loading: 'Rejecting access request...',
            success: 'Access request rejected successfully!',
            error: 'Error rejecting request. Please try again.',
          }
        );
      
        try {
          const response = await promise;
          const data = response.data;
      
          // optional: only remove if success confirmed
          if (response.status === 200) {
            setRequests((prev) => prev.filter((user) => user.uid !== uid));
          }
        } catch (error) {
          console.error('Error rejecting request:', error);
          // error toast already shown by toast.promise
        }
      };


  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <Toaster />
      <div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg p-6">
        <h2 className="text-2xl font-bold mb-6 text-[#015d81] text-center">
          Pending Access Requests
        </h2>

        {loading ? (
          <p className="text-center text-gray-500">Loading...</p>
        ) : requests.length === 0 ? (
          <p className="text-center text-gray-500">No pending requests 🎉</p>
        ) : (
          <div className="space-y-4">
            {requests.map((user) => (
              <div
                key={user.uid}
                className="flex justify-between items-center bg-gray-50 p-4 rounded-md shadow-sm"
              >
                <div>
                  <p className="font-semibold text-gray-800">
                    Username:{user.username}
                  </p>
                  <p className="font-semibold text-gray-800">
                    Name:{user.name}
                  </p>
                  <p className="text-sm text-gray-500">gmail:{user.email}</p>
                  <p className="text-xs text-gray-400">UID: {user.uid}</p>
                </div>
                <div className="flex gap-3">
                  <button
                    className="bg-green-500 text-white px-4 py-1 rounded hover:bg-green-600 transition"
                    onClick={() => {handleApproveRequest(user.uid)}}
                  >
                    Approve
                  </button>
                  <button
                    className="bg-red-500 text-white px-4 py-1 rounded hover:bg-red-600 transition"
                    onClick={() => {handleRejectRequest(user.uid)}}
                  >
                    Reject
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default AccessRequests;
